module.exports = __webpack_public_path__ + "static/toasted-siopao-9d5061caf704b37859de46454a2b3309.jpg";